import type { HouseholdMember } from '@chore-project/shared';

export function MemberAvatar({
  member,
  size = '2rem',
  fontSize = '0.85rem',
}: {
  member: HouseholdMember;
  size?: string;
  fontSize?: string;
}) {
  const bg = member.avatarColor || 'var(--primary)';
  const label = (member.memberName || member.email || '?')[0]?.toUpperCase() ?? '?';
  return (
    <div
      className="avatar"
      style={{ width: size, height: size, fontSize, background: bg, color: '#fff', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      {member.avatarIcon
        ? <ion-icon name={member.avatarIcon} style={{ color: '#fff', fontSize: '1.1em' }} />
        : label}
    </div>
  );
}
